module.exports = __webpack_public_path__ + "static/media/acacia-mall-interior-02.62f0799b.webp";